<template>
  <div>
    <el-upload
      class="avatar-uploader"
      :show-file-list="false"
      :on-change="handleUpload"
      :before-upload="beforeUpload"
      :auto-upload="false"
      :disabled="!editMode"
      list-type="picture-card"
      action="#"
    >
      <div
        v-if="imageUrl"
        @mouseover="showButtons = true"
        @mouseleave="showButtons = false"
      >
        <el-image
          :src="isHttp ? imageUrl : formatImgUrl(imageUrl)"
          class="image-style"
          fit="cover"
        ></el-image>
        <div v-show="showButtons" class="overlay">
          <i class="el-icon-edit" v-show="editMode"></i>
          <i class="el-icon-view" @click.stop="previewImage"></i>
          <i class="el-icon-delete" v-show="showDel" @click.stop="deleteImage"></i>
        </div>
      </div>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <!-- 模态窗口 -->
    <el-dialog
      :visible.sync="previewVisible"
      width="60%"
      :append-to-body="appendToBody"
    >
      <img
        :src="isHttp ? imageUrl : formatImgUrl(imageUrl)"
        alt="Preview Image"
        style="width: 100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getSignUp, upOssSave } from "@/api/file";
// import { v4 as uuid } from 'uuid';
export default {
  name: "ImageUpload",
  props: {
    imageUrl: String,
    editMode: {
      default: true,
      type: Boolean
    }, //是否可以编辑
    appendToBody: {
      default: true,
      type: Boolean
    }, //是否嵌套在 dialog 里面
    maxSize: {
      default: 10,
      type: Number
    },
    //是都是有闲有品的数据
    isHttp: {
      default: false,
      type: Boolean
    },
    showDel:{
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      showButtons: false,
      previewVisible: false // 控制预览窗口的显示
    };
  },
  methods: {
    formatImgUrl(value) {
      return (
        process.env.BASE_API +
        `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${value}`
      );
    },
    async handleUpload(file, fileList) {
      if (this.beforeUpload(file)) {
        const signUpResult = await getSignUp(); //获取签名
        if (signUpResult.statusCode == 200) {
          const {
            accessid,
            dir,
            expire,
            policy,
            signature
          } = signUpResult.data;

          const newFileName = `${Date.now()}${file.name}`;
          const keyStr = `${dir}${newFileName}`;
          const formData = new FormData();

          formData.append("key", keyStr);
          formData.append("OSSAccessKeyId", accessid);
          formData.append("policy", policy);
          formData.append("Signature", signature);
          formData.append("Expires", expire);
          formData.append("successActionStatus", 200);
          formData.append("file", file.raw);
          //上传到 oss
          upOssSave(formData).then(res => {
            this.$emit("success", newFileName);
            this.$message.success("上传成功!");
          });
        }
      }
    },
    async handleUpload2(file, fileList) {
      if (this.beforeUpload(file)) {
        const signUpResult = await getSignUp(); //获取签名
        if (signUpResult.statusCode == 200) {
          const {
            accessid,
            dir,
            expire,
            policy,
            signature
          } = signUpResult.data;
          const keyStr = `${dir}${file.name}`;
          const formData = new FormData();

          formData.append("key", keyStr);
          formData.append("OSSAccessKeyId", accessid);
          formData.append("policy", policy);
          formData.append("Signature", signature);
          formData.append("Expires", expire);
          formData.append("successActionStatus", 200);
          formData.append("file", file.raw);
          //上传到 oss
          upOssSave(formData).then(res => {
            this.$emit("success", file.name);
            this.$message.success("上传成功!");
          });
        }
      }
    },
    beforeUpload(file) {
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        return false;
      }
      console.log(file.size,'这个上传组件是componments文件');
      const isLt2M = file.size / 1024 / 1024 <= this.maxSize;
      if (!isLt2M) {
        this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`);
        return false;
      }
      return true;
    },
    deleteImage() {
      this.$emit("delete", this.imageUrl); // 触发删除事件
      this.imageUrl = null; // 清空图片URL
      this.$message.success("图片已删除!"); // 提示用户
    },
    previewImage() {
      this.previewVisible = true; // 显示预览窗口
    }
  }
};
</script>
<style lang="scss">
.avatar-uploader {
  position: relative;
  margin-right: 20px;
  display: inline-block;
  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  .avatar-uploader .avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    line-height: 80px;
    text-align: center;
  }

  .overlay {
    position: absolute;
    width: 80px;
    height: 80px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    i {
      color: #fff;
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Upload/ImageUpload.vue